import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Welcome to Maison Luxe.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-nude mt-24">
      {/* Newsletter */}
      <section className="border-b border-stone-line">
        <div className="max-w-5xl mx-auto px-6 py-20 text-center">
          <p className="small-label">The Maison List</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
            Get exclusive wig deals & beauty tips.
          </h2>
          <p className="text-stone mt-4 text-sm max-w-md mx-auto">
            Join 12,000+ South African women receiving early access to drops, styling guides and members-only pricing.
          </p>
          <form onSubmit={subscribe} className="mt-8 flex flex-col sm:flex-row gap-2 max-w-md mx-auto">
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-ivory border border-stone-line rounded-full px-5 py-3.5 text-sm placeholder:text-stone focus:outline-none focus:ring-1 focus:ring-charcoal"
            />
            <button
              data-testid="newsletter-submit-button"
              disabled={busy}
              className="btn-primary"
            >
              {busy ? "Adding…" : "Subscribe"}
            </button>
          </form>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <Link to="/" className="font-serif text-2xl">Maison Luxe</Link>
          <p className="mt-4 text-sm text-stone leading-relaxed max-w-sm">
            Premium human-hair and HD-lace wigs for the modern South African woman.
            Hand-finished, beginner-friendly, undetectable.
          </p>
          <div className="mt-6 space-y-2 text-sm text-stone">
            <p className="flex items-center gap-2"><MapPin strokeWidth={1.5} className="w-4 h-4" /> Sandton, Johannesburg</p>
            <p className="flex items-center gap-2"><Phone strokeWidth={1.5} className="w-4 h-4" /> +27 11 555 0123</p>
            <p className="flex items-center gap-2"><Mail strokeWidth={1.5} className="w-4 h-4" /> hello@maisonluxe.co.za</p>
          </div>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-5 text-sm hover:text-gold">
            <Instagram strokeWidth={1.5} className="w-4 h-4" /> @maisonluxe.za
          </a>
        </div>
        <div>
          <p className="small-label">Shop</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-gold">All Wigs</Link></li>
            <li><Link to="/collections/hd-lace" className="hover:text-gold">HD Lace</Link></li>
            <li><Link to="/collections/glueless" className="hover:text-gold">Glueless</Link></li>
            <li><Link to="/collections/blonde" className="hover:text-gold">Blonde</Link></li>
            <li><Link to="/collections/best-sellers" className="hover:text-gold">Best Sellers</Link></li>
            <li><Link to="/collections/long" className="hover:text-gold">Long Wigs</Link></li>
          </ul>
        </div>
        <div>
          <p className="small-label">Support</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-gold">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            <li><Link to="/track-order" className="hover:text-gold">Track Order</Link></li>
            <li><Link to="/policies/shipping" className="hover:text-gold">Shipping Policy</Link></li>
            <li><Link to="/policies/refund" className="hover:text-gold">Refund Policy</Link></li>
            <li><Link to="/policies/privacy" className="hover:text-gold">Privacy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-gold">Terms</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-line">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-stone">
          <p>© {new Date().getFullYear()} Maison Luxe (Pty) Ltd. All rights reserved.</p>
          <p className="flex items-center gap-3 tracking-luxe uppercase">
            <span>Yoco</span><span>•</span><span>PayFast</span><span>•</span><span>Ozow</span><span>•</span><span>Payflex</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
